export const TABS_OPTIONS = [
  { label: 'Organization details', value: 'general' }
]
